// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__tE-kc","title":"BackImages_title__3RZIv","images":"BackImages_images__S5HsG"};